import script from "./NewsfeedPostScheduler.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsfeedPostScheduler.vue?vue&type=script&setup=true&lang=js"

import "./NewsfeedPostScheduler.vue?vue&type=style&index=0&id=33da717a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33da717a"]])

export default __exports__